module.exports = __webpack_public_path__ + "static/media/logo-full.7ed1de1d.png";